import React from 'react'
import '../../style/PianiDisponibili.scss'
import {ReactComponent as HappyFace} from '../../assets/new-icons/ricaricabileFace.svg';
import {ReactComponent as MhFace} from '../../assets/new-icons/relaxFace.svg';
import {ReactComponent as SadFace} from '../../assets/new-icons/tradizionaleFace.svg';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import StarIcon from '@mui/icons-material/Star';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

function HaveMethod() {
    const navigate = useNavigate()
    const idGroup = useSelector((user) => user.user.idGruppo)
    const priceKwhPos = useSelector((user) => user.user.nuoviDatiContratto.mono_positivo)
    const priceKwhNeg = useSelector((user) => user.user.nuoviDatiContratto.mono_negativo)
    const cards = [
        {id: 1, price: parseFloat(priceKwhPos).toFixed(2).replace(/\./g, ","), tipo: 'Ricaricabile', descrizione: 'Ricaricheremo automaticamente il tuo saldo per non farlo andare mai in negativo.', icon: <HappyFace />, url: '/enrica/piano-ricaricabile'},
        {id: 2, price: parseFloat(priceKwhNeg - 0.02).toFixed(2).replace(/\./g, ","), tipo: 'Relax', descrizione: "Ogni inizio mese ricaricheremo l'equivalente di un mese di fornitura media.", icon: <MhFace />, url: '/enrica/piano-relax'},
        {id: 3, price: parseFloat(priceKwhNeg).toFixed(2).replace(/\./g, ","), tipo: 'Tradizionale', descrizione: 'Paghi alla scadenza dei consumi. Il totale da pagare è calcolato al prezzo di listino standard.', icon: <SadFace />, url: '/enrica/piano-tradizionale'}
    ]
    const idGourToString = () => {
        switch (idGroup) {
            case 1:
                return 'green'
            case 2:
                return 'orange'
        
            default:
                return 'red';
        }
    }
    return (
        <div className="haveMethod">
            {cards.map((card, i) => (
                <div key={i} className={`box ${card.id === idGroup ? `disabled ${idGourToString()}` : ''}`} onClick={() => card.id === idGroup ? null : navigate(card.url)}>
                    {card.id === idGroup ? (
                        <div className="badge">
                            <p>Piano attuale </p>
                            <DoneAllIcon/>
                        </div>
                    ) : card.id === 1 ? (
                        <div className="badge">
                            <p>Il miglior prezzo </p>
                            <StarIcon/>
                        </div>
                    ) : null}
                    <div className='columnCard'>
                        <div className="customRow">
                            <div className={`icon ${card.price === parseFloat(priceKwhPos).toFixed(2).replace(/\./g, ",") ? 'green' : card.price === parseFloat(priceKwhNeg - 0.02).toFixed(2).replace(/\./g, ",") ? 'orange' : 'red'}`}>
                                {card.icon}
                            </div>
                            {/* In test si vedrà sempre verde perché ho l'offerta dipendenti */}
                            <div className="column">
                                <p className={`price ${card.price === parseFloat(priceKwhPos).toFixed(2).replace(/\./g, ",") ? 'green' : card.price === parseFloat(priceKwhNeg - 0.02).toFixed(2).replace(/\./g, ",") ? 'orange' : 'red'}`}>{card.price} <span>€/kWh</span></p>
                                <p className="tipologia">{card.tipo}</p>
                                <p className="paghi">{card.descrizione}</p>
                            </div>
                            <div className="arrow">
                                <ArrowForwardIosIcon />
                            </div>
                        </div>
                        

                    </div>
                </div>
            ))}
        </div>
    )
}

export default HaveMethod
